"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MosaicDropTargetPosition = void 0;
exports.MosaicDropTargetPosition = {
    TOP: 'top',
    BOTTOM: 'bottom',
    LEFT: 'left',
    RIGHT: 'right',
};
//# sourceMappingURL=internalTypes.js.map